import React from 'react';

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  disabled = false,
  loading = false,
  // "= undefined" makes the prop optional for TypeScript callers.
  icon: Icon = undefined,
  // Extra classes for the icon, for example 'animate-spin' while an action runs.
  iconClassName = '',
  iconPosition = 'left',
  className = '',
  onClick = undefined,
  type = 'button',
  ...props
}) => {
  const baseClasses = 'inline-flex items-center justify-center font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap';
  
  const variantClasses = {
    primary: 'bg-naviter-blue text-white hover:bg-naviter-blue-dark focus:ring-naviter-blue border border-transparent',
    secondary: 'bg-white text-gray-700 hover:bg-gray-50 focus:ring-naviter-blue border border-gray-300',
    danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500 border border-transparent',
    ghost: 'bg-transparent text-gray-700 hover:bg-gray-100 focus:ring-naviter-blue border border-transparent'
  };

  const sizeClasses = {
    xs: 'px-2 py-1 text-xs',
    sm: 'px-3 py-1.5 text-xs',
    md: 'px-4 py-2 text-sm',
    lg: 'px-6 py-3 text-base'
  };

  const iconSize = {
    xs: 12,
    sm: 14,
    md: 16,
    lg: 18
  };

  const classes = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`.trim();

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || loading}
      onClick={onClick}
      {...props}
    >
      {loading ? (
        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-current mr-2" />
      ) : Icon && iconPosition === 'left' ? (
        <Icon size={iconSize[size]} className={`mr-2 ${iconClassName}`.trim()} />
      ) : null}
      
      {children}
      
      {!loading && Icon && iconPosition === 'right' ? (
        <Icon size={iconSize[size]} className={`ml-2 ${iconClassName}`.trim()} />
      ) : null}
    </button>
  );
};

export default Button;
